import { ApprovalStatusEnum, approvalStatusDisplay } from '@api';
import { Error, PublishedWithChanges, Verified } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { IconMenuItem, IconMenuItemProps } from '@views/components/IconMenuItem';
import { useParams } from 'react-router-dom';


interface DataRequestsMenuListItemProps extends IconMenuItemProps {
    tab?: string;
    status?: ApprovalStatusEnum;
}

export function DataRequestsMenuListItem({
    tab, status, selected, ...props
}: DataRequestsMenuListItemProps) {
    const { dataRequestID } = useParams();

    return (
        <IconMenuItem
            to={`${dataRequestID ? './../' : ''}${tab || ''}`}
            icon={(
                <Tooltip title={status ? approvalStatusDisplay[status] : ''}>
                    {status === 'SUBMITTED' ? (
                        <PublishedWithChanges fontSize="small" />
                    ) : status === 'APPROVED' ? (
                        <Verified
                            fontSize="small"
                            color="success"
                        />
                    ) : status === 'REJECTED' ? (
                        <Error
                            color="error"
                            fontSize="small"
                        />
                    ) : <span />}
                </Tooltip>
            )}
            selected={selected !== undefined ? selected : !!dataRequestID && dataRequestID === tab}
            {...props}
        />
    );
}
